import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { approveUserAction } from '../../redux/actions/userActions'

const AproveUser = ({ setShowApproval, user }) => {



    const dispatch = useDispatch()

    const [referal_id, setReferal_id] = useState("")
    const [admin_id, setAdmin_id] = useState("")
    const { error,message } = useSelector(state => state.inviteUser)





    const handleSubmit = () => {



        if (user?.role === "PMM" && admin_id.trim() === "") {

            toast.error("Admin ID is required for PMM");
            return;
        }


        dispatch(approveUserAction({ referal_id, admin_id, user_id: user.id }))



    }

    useEffect(() => {

        if (error) {

            return;
        }

        if (message) {

            setShowApproval(false);
            setReferal_id("");
            setAdmin_id("");
        }

    }, [error,message, setShowApproval])



    return (
        <Fragment>
            <section className="fixed inset-0 z-[999999999] bg-black/40 backdrop-blur-sm flex justify-center items-start pt-[5vmax]">

                <div className="w-[35%] bg-white rounded-2xl p-[1.5vmax] shadow-2xl animate-[fadeIn_.2s_ease]">

                    {/* CLOSE */}
                    <div className="flex justify-end">
                        <button
                            className="text-gray-500 w-[2vmax] bg-gray-100 rounded-full grid place-items-center hover:bg-gray-200"
                            onClick={() => setShowApproval(false)}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>

                    <div className="flex-center flex-col">
                        <h2 className="text-[1.8vmax] font-semibold text-gray-800 mb-[1vmax]">Approve User</h2>

                        <div className="w-full flex flex-col gap-[1vmax]">

                            <div className="flex flex-col gap-[0.5vmax]">
                                <label className="text-[1.1vmax] font-semibold text-gray-800" htmlFor="referal_id">Referal ID</label>
                                <input
                                    type="text"
                                    name="referal_id"
                                    id="referal_id"
                                    value={referal_id}
                                    onChange={(e) => setReferal_id(e.target.value)}
                                    placeholder="Enter referal id"
                                    className="w-full p-[0.5vmax] border border-gray-300 rounded-lg"
                                />
                            </div>

                            {user?.role === "PMM" &&
                                <div className="flex flex-col gap-[0.5vmax]">
                                    <label className="text-[1.1vmax] font-semibold text-gray-800" htmlFor="admin_id">
                                        Admin ID
                                        {' '}
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="admin_id"
                                        id="admin_id"
                                        value={admin_id}
                                        onChange={(e) => setAdmin_id(e.target.value)}
                                        placeholder="Enter admin id"
                                        className="w-full p-[0.5vmax] border border-gray-300 rounded-lg"
                                    />
                                </div>

                            }

                        </div>

                        <div className="flex-center gap-[1vmax] mt-[2vmax]">
                            <button
                                className="bg-gray-500 text-white text-[1.1vmax] py-[0.5vmax] px-[2vmax] rounded-lg"
                                onClick={() => setShowApproval(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-[var(--primary)] text-white text-[1.1vmax] py-[0.5vmax] px-[2vmax] rounded-lg"
                                onClick={() => handleSubmit()}
                            >
                                Approve
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default AproveUser
